export default "__VITE_ASSET__BRBQOelT__"